import { render, staticRenderFns } from "./RelatorioCotasClienteListFiltro.vue?vue&type=template&id=889baf0a"
import script from "./RelatorioCotasClienteListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasClienteListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports